import React from "react";
import useStyles from "./styles";
import { IconButton } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import DPTooltip from "../DPTooltip/DPTooltip";

interface DPHelpTooltipProps {
  title: NonNullable<React.ReactNode>;
  width?: number;
}

const DPHelpTooltip = ({ title, width }: DPHelpTooltipProps) => {
  const classes = useStyles();

  return (
    <DPTooltip
      title={title}
      width={width}
    >
      <IconButton className={classes.helpIconButton}>
        <HelpIcon color="primary" className={classes.icon} />
      </IconButton>
    </DPTooltip>
  );
};

export default DPHelpTooltip;
